import { Injectable } from '@angular/core';
import { IShellEvent } from './IShellEvent';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { OrdersNavigationService, OrdersRowClickedPayload } from 'app/doctors/orders/orders-navigation.service';

@Injectable({ providedIn: 'root' })
export class ShellOrdersRowClickedEvent implements IShellEvent {
	constructor(private readonly ordersNavigationService: OrdersNavigationService) {}

	get eventName(): string {
		return ShellCommunicationEvents.OrdersRowClicked;
	}

	handleCustomEvent(event: any): void {
		const payload = event.data as OrdersRowClickedPayload;
		this.ordersNavigationService.handleRowClicked(payload);
	}

	handlePostMessage(_event: any): void {
		// orders-row-clicked is channel-based only; postMessage not used
	}
}
